<template>
  <b-card no-body class="card card-image-content card-type-content overflow-hidden">
    <deal-header-chat
      v-if="chat_deal"
      :title="chat_deal.title"
      :price="chat_deal.price"
    />
    <div class="p-1">
    <div class="mb-1 d-flex align-items-center">
      <div class="position-relative mr-1">
        <b-avatar
          size="3.5rem"
          variant="light-secondary"
          :src="verifyAsset(avatar_src)"
        ></b-avatar>
      </div>

      <div class="d-flex flex-column">
        <span v-if="message.sender">
          {{ message.sender.first_name || '' }} {{ message.sender.last_name || '' }}
          <image-verified />
        </span>
        <small class="text-muted"> {{ $t("campaigns.post") }} · {{ $t('creator.textNow')}} </small>
      </div>

      <div class="ml-auto d-flex align-items-center">
        <feather-icon
          icon="DownloadIcon"
          class="cursor-pointer text-primary"
          @click="downloadAsset"
        />
      </div>
    </div>

    <div>
      <video
        class="w-100 max-height-video-content"
        :src="asset_url"
        :autoplay="false"
        :loop="true"
        controls
        controlsList="nodownload"
        ref="video"
        v-if="type_content === 'video'"
      ></video>
      <img
        v-if="type_content === 'image'"
        class="card-image-content"
        :src="asset_url"
        @error="errorLoad(message.uuid)"
      />
    </div>
    <div class="card-content-all">
      <div class="container-interactions">
        <div
          class="d-flex justify-content-between align-items-center w-100 avenir-light mb-05 flex-wrap mt-1"
        >
          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center mr-05">
              <b-icon class="mr-05" icon="play-circle" />
              <span>{{ getFormat(getRandomNumber()) }}</span>
            </div>
            <div class="d-flex align-items-center mr-05">
              <b-icon class="mr-05" icon="heart-fill" />
              <span>{{ getFormat(getRandomNumber()) }}</span>
            </div>
            <div class="d-flex align-items-center mr-05">
              <b-icon class="mr-05" icon="chat" />
              <span>{{ getFormat(getRandomNumber()) }}</span>
            </div>
          </div>
        </div>
        <div class="metric-row">
          <span class="avenir-light">{{ $t("campaigns.shareTime") }}</span>
          <span class="metric-line"></span>
          <span>{{ getFormat(getRandomNumber()) }}</span>
        </div>
        <div class="text-start avenir-light text-overflow w-100" :class="{'my-1 border-bottom': local_show_btns && !show_modal_change}">
          {{ message.text_publish }}
        </div>
        <div class="w-100" v-if="local_show_btns && !show_modal_change">
          <b-button
            @click="openRevisionModal"
            variant="outline-dark"
            class="w-100 mb-05"
            >{{ $t("creator.requestRevision") }}</b-button
          >
          <b-button
            @click="openAcceptModal"
            variant="blue-button"
            class="w-100 blue-button"
            >{{ $t("creator.acceptContentDeal") }}</b-button
          >
        </div>
        <div v-if="show_modal_change" class="mt-1 pt-1 border-top w-100">
          <div v-if="!modal_accept">
            <div class="w-100">
              <h5>{{ $t("creator.requestRevision") }}</h5>
              <b-form-textarea
                class="mt-1"
                v-model="revision_text"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
              <div class="mt-1 actions-buttons">
                <b-button
                  @click="hiddenModalChange()"
                  variant="light"
                  :disabled="is_loading"
                  >{{ $t("creator.cancel") }}</b-button
                >
                <b-button
                  variant="blue-button"
                  :disabled="!revision_text || is_loading"
                  @click="submitRequestRevision()"
                  class="blue-button"
                  >
                  <b-spinner v-if="is_loading" style="width:14px;height:14px;" class="mr-50" />
                  {{ $t("creator.submit") }}</b-button
                >
              </div>
            </div>
          </div>
          <div v-else>
            <h5>{{ $t("creator.collaborationAccepted") }}</h5>
            <span class="text-muted">{{ $t("creator.byAcceptDeal") }}</span>
            <div class="mt-1">
              <b-form-checkbox v-model="accept_contents"> {{ $t("creator.contentAccept") }} </b-form-checkbox>
            </div>

            <div class="mt-1 actions-buttons">
              <b-button
                @click="hiddenModalChange()"
                variant="light"
                :disabled="is_loading"
                >{{ $t("creator.cancel") }}</b-button
              >
              <b-button
                @click="submitAcceptContents()"
                class="blue-button-next-step"
                variant="blue-button-next-step"
                :disabled="is_loading"
                >
                <b-spinner v-if="is_loading" style="width:14px;height:14px;" class="mr-50" />
                {{ $t("creator.submit") }}</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </b-card>
</template>

  
<script>
import {
  BCard,
  BAvatar,
  BIcon,
  BButton,
  BSpinner,
  BFormTextarea,
  BFormCheckbox,
} from "bootstrap-vue";
import { getFormat, decimalFixed } from "@/libs/utils/formats";
import { getIconWhite, getIconColor } from "@/libs/utils/icons";
import { verifyAsset } from "@/libs/utils/urls";
import chat_service from "@/services/chat";
import { showToast } from '@/libs/utils/others';
import { submitAcceptContentsUseCase, submitRequestRevisionUseCase } from '@/application/proposals/chats.usecase';

export default {
  name: "view-file-chats",
  components: {
    BCard,
    BAvatar,
    BIcon,
    BButton,
    BSpinner,
    BFormTextarea,
    BFormCheckbox,
    ImageVerified: () => import("@/views/components/image/ImageVerified.vue"),
    DealHeaderChat: () => import("@/views/pages/proposals/chat/dealHeaderChat.vue"),
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    show_btns: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      decimalFixed,
      getIconWhite,
      getIconColor,
      verifyAsset,
      getFormat,
      asset_url: "",
      type_content: "",
      show_modal_change: false,
      change_modal: 0,
      revision_text: "",
      accept_contents: false,
      modal_accept: false,
      local_show_btns: this.show_btns,
      is_loading: false,
    };
  },
  created() {
    this.formatMsj(this.message);
  },
  computed: {
    avatar_src() {
      return this.message?.sender?.avatar || ""
    },
    chat_deal() {
      return this.message?.chat_deals?.deal || null;
    },
    uuid_chat_deal() {
      return this.message?.chat_deals?.uuid || null;
    },
  },
  methods: {
    hiddenModalChange() {
      this.show_modal_change = false;
      this.change_modal = this.change_modal + 1;
      this.revision_text = "";
      this.accept_contents = false;
      this.modal_accept = false;
    },
    openRevisionModal() {
      this.openModalChange(false);
    },

    openAcceptModal() {
      this.openModalChange(true);
    },

    openModalChange(is_accept) {
      this.show_modal_change = true;
      this.change_modal++;
      this.modal_accept = is_accept;
    },
    async submitAcceptContents() {
      this.is_loading = true;
      try {
        await submitAcceptContentsUseCase({
          uuid_chat_deal: this.uuid_chat_deal,
          accept_contents: this.accept_contents
        });
        this.modal_accept = false;
        this.show_modal_change = false;

        this.$emit("approved");
        this.local_show_btns = false;

        showToast(
          this,
          'success',
          'CheckCircleIcon',
          'creator.acceptedContentTitle',
          'creator.acceptedContentText'
        );

      } catch (error) {
        if (error.message === "NEED_CONFIRM") {
          showToast(this, 'danger', 'AlertCircleIcon', 'creator.needConfirm');
        } else {
          showToast(this, 'danger', 'AlertCircleIcon', 'creator.errorContent');
        }
      } finally {
        this.is_loading = false;
      }
    },

    async submitRequestRevision() {
      this.is_loading = true;
      try {
        const response = await submitRequestRevisionUseCase({
          uuid_chat_deal: this.uuid_chat_deal,
          revision_text: this.revision_text
        });

        this.$emit("request_sent", response);
        this.local_show_btns = false;
        this.hiddenModalChange();

        showToast(
          this,
          'success',
          'CheckCircleIcon',
          'creator.requestSentTitle',
          'creator.requestSentText'
        );

      } catch (error) {
        showToast(this, 'danger', 'AlertCircleIcon', 'creator.errorSendChange');
      } finally {
        this.is_loading = false;
      }
    },

    downloadAsset() {
      if (this.type_content === "image") {
        window.open(this.asset_url, "_blank");
      } else {
        const link = document.createElement("a");
        link.href = this.asset_url;

        const filename = this.asset_url.split("/").pop() || "archivo";

        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    errorLoad(uuid) {
      chat_service.getAssetContentUrlV4(uuid).then((response) => {
        const img_new = response.file;
        this.asset_url = img_new;
      });
    },
    getRandomNumber() {
      return Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000;
    },
    formatMsj(message) {
      const asset = message.file;
      const videoExtensions = ["mp4", "webm", "ogg", "mov", "avi", "mkv"];
      const imageExtensions = [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "webp",
        "svg",
        "avif",
        "heic",
      ];
      let type = "unknown";

      try {
        const url = new URL(asset, window.location.origin);
        const ext = url.pathname.split(".").pop().toLowerCase();
        if (videoExtensions.includes(ext)) {
          type = "video";
        } else if (imageExtensions.includes(ext)) {
          type = "image";
        }
      } catch {
        type = "unknown";
      }

      this.asset_url = verifyAsset(asset);
      this.type_content = type;
    },
  },
};
</script>
  
<style scoped>
.max-height-video-content {
  max-height: 320px;
}
.metric-row {
  display: flex;
  align-items: center;
  width: 100%;
}
.metric-line {
  flex-grow: 1;
  border-bottom: 1px dashed #ccc;
  margin: 0 8px;
}
.container-interactions {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.card-content-all {
  width: 100%;
}
.card-image-content {
  width: 100%;
  object-fit: cover;
  height: 300px;
  border-radius: 1%;
  box-shadow: none !important;
}
.card-type-content {
  display: flex;
  height: 90%;
  border: 1px solid #ccccccb0;
  border-radius: 1em;
}
.text-overflow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.info-right {
  border-left: 7px solid #55a6c4;
  background: white;
  border-radius: 10px;
  border: 1px solid #ccccccb0;
}
.actions-buttons {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.75rem;
}
@media (max-width: 576px) {
  .actions-buttons {
    flex-direction: column-reverse;
  }
  .actions-buttons .btn {
    width: 100%;
  }
}
</style>